import { useEffect } from 'react';
import withStorage from '../../components/withWebStorage';
import { useAuth } from 'react-oidc-context';
import { BaseRoute } from 'constants/routes';
import { LocalStorageKeys } from './modules/constants';

// Redirect to login page
export const NotAuthorized = ({ location, store }) => {
  const auth = useAuth();
  // Return Login page with the current url as redirect
  const originalRequestURL = window.location.href.split(`${BaseRoute}/`)[1];
  if (
    originalRequestURL &&
    originalRequestURL.indexOf('login') < 0 &&
    originalRequestURL.indexOf('logout') < 0 &&
    !originalRequestURL.startsWith('auth')
  ) {
    // Store the original request url in the local storage
    localStorage.setItem(LocalStorageKeys.originalRequestURL, originalRequestURL);
  }
  useEffect(() => {
    // Redirect to Optum Login
    auth.signinRedirect();
  }, []);
  return <div />;
};

export default withStorage(NotAuthorized);
